module.exports = __webpack_public_path__ + "static/media/Barry_Migliorini.8e185d20.png";